import { z } from 'zod';

const conditionsSchema = z.object({
  conditions: z.array(z.object({
    answer: z.string().nullable().default(null),
    goTo: z.union([z.literal("next"), z.literal("result"), z.string()]).nullable().default(null)
  })).default([]),
  otherwiseGoTo: z.union([z.object({
    onCorrect: z.union([z.literal("next"), z.literal("result"), z.string()]).nullable().default(null),
    onPartial: z.union([z.literal("next"), z.literal("result"), z.string()]).nullable().default(null),
    onIncorrect: z.union([z.literal("next"), z.literal("result"), z.string()]).nullable().default(null)
  }).default({
    onCorrect: null,
    onIncorrect: null,
    onPartial: null
  }),
  // otherwiseGoTo was extended to support both onCorrect and
  // onIncorrect by ADO #124215
  z.union([z.literal("next"), z.literal("result"), z.string()]).nullable().default(null).transform(val => ({
    onCorrect: val,
    onPartial: val,
    onIncorrect: val
  }))])
});
const hintsSchema = z.array(z.object({
  showAtAttempt: z.number(),
  text: z.string()
})).default([]);
const taskDescriptorSchema = z.object({
  type: z.literal("task"),
  id: z.string(),
  title: z.string(),
  hints: hintsSchema,
  conditions: conditionsSchema.nullish().default(null)
});
const folderDescriptorSchema = z.object({
  type: z.literal("folder"),
  id: z.string(),
  title: z.string(),
  tasksToTake: z.number()
});
const stackDescriptorSchema = z.object({
  type: z.literal("stack"),
  id: z.string(),
  title: z.string(),
  tasks: z.array(taskDescriptorSchema)
});

export { conditionsSchema, folderDescriptorSchema, hintsSchema, stackDescriptorSchema, taskDescriptorSchema };
//# sourceMappingURL=schema.v2.descriptor.js.map
